/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 84,
    height: 84,
    viewBox: '0 0 84 84',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><path pid="0" d="M28.25 43.25h10.5v10.5c0 1.275.975 2.25 2.25 2.25s2.25-.975 2.25-2.25v-10.5h10.5c1.275 0 2.25-.975 2.25-2.25s-.975-2.25-2.25-2.25h-10.5v-10.5c0-1.275-.975-2.25-2.25-2.25s-2.25.975-2.25 2.25v10.5h-10.5c-1.275 0-2.25.975-2.25 2.25s1.05 2.25 2.25 2.25" _fill="#EF7D01"/><circle pid="1" class="svg-circle" cx="41" cy="41" r="41"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/add.js